import { render } from "./ShowtimesEditor.vue?vue&type=template&id=64ba771a&scoped=true"
import script from "./ShowtimesEditor.vue?vue&type=script&lang=js"
export * from "./ShowtimesEditor.vue?vue&type=script&lang=js"

import "./ShowtimesEditor.vue?vue&type=style&index=0&id=64ba771a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ba771a"]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QSelect,QTooltip,QItem,QItemSection,QChip,QCheckbox,QItemLabel,QSlider,QRadio,QInput});
